// extracted by mini-css-extract-plugin
export default {"privacypolicy":"PrivacyPolicy_privacypolicy__pKoHd"};